import type { IncentiveTypes } from '../incentiveTypes';

export const INCENTIVE_TYPE_VALUES: IncentiveTypes = {
    customerCash: { value: 'CustomerCash', label: 'Rebate' },
    dealerCash: { value: 'DealerCash', label: 'Dealer Cash' }
};

export const NON_MANUAL_INCENTIVE_DISPLAY_TYPES = {
    manufacturer: 'Manufacturer',
    included: 'Included',
    conditional: 'Conditional'
} as const;
